import { InputField } from "./InputField";
import type { UtdoLyrics } from "../types";
import { convertToUrl } from "../util/convert-to-url";
import { toNullableInt, toString } from "../util/converters";

type LyricsEditorProps = {
    lyrics: UtdoLyrics;
    validate: (lyrics: UtdoLyrics) => any;
    cancel: () => any;
};

export function LyricsEditor(props: LyricsEditorProps) {
    let idRef!: HTMLInputElement;
    let titleRef!: HTMLInputElement;
    let urlRef!: HTMLInputElement;
    let lyricsRef!: HTMLTextAreaElement;

    const cancel = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        props.cancel();
    };

    const transform = () => {
        urlRef.value = convertToUrl(titleRef.value);
    };

    const validate = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        const id = toNullableInt(idRef.value);
        const title = toString(titleRef.value);
        const url = toString(urlRef.value);
        const lyrics = toString(lyricsRef.value);
        props.validate({
            id,
            title,
            url,
            lyrics,
        });
    };

    return <form onSubmit={validate} autocomplete="off">
        <input ref={idRef} type="hidden" value={props.lyrics.id}/>
        <InputField
            ref={titleRef}
            type="text"
            id="lyrics-name"
            label="Nom"
            required
            onChange={transform}
            value={props.lyrics.title}/>
        <InputField
            ref={urlRef}
            type="text"
            id="lyrics-url"
            label="Url"
            required
            value={props.lyrics.url}/>
        <InputField
            ref={lyricsRef}
            type="textarea"
            id="lyrics-lyrics"
            label="Paroles"
            required
            value={props.lyrics.lyrics}/>
        <div class="actions">
            <input type="submit" value="Enregistrer" class="accent" />
            <button onClick={cancel}>Annuler</button>
        </div>
    </form>;
}